<template>
  <q-page fluid style="min-height: 0px">
    <div class="row">
      <div ref="titleOfPage" class="col-12 text-center bg-primary text-white">
        <h4 class="q-py-none q-mb-none pwa-heading">
          Scheduled Moisture Surveys
        </h4>
        <p>Select a survey to start</p>
      </div>

      <q-separator class="col-12" style="height: 1px" />
      <div :style="`height: calc(100vh - ${maxHeight}px)`" class="col-12">
        <datatable
          :data="scheduledSurveys"
          :columns="columns"
          :separator="separator"
          @rowSelected="handleDoubleClick"
          @rowDoubleClick="handleDoubleClick"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import datatable from "@/components/datatable/datatable.vue";

export default {
  components: { datatable },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentUserData",
      "scheduledSurveys",
      "scheduledSurveysLoading",
    ]),
  },
  props: {
    source: String,
  },
  watch: {},
  data: () => ({
    maxHeight: 300,
    columns: [
      {
        name: "Start Date",
        required: true,
        label: "Date",
        align: "left",
        field: (row) => row.date,
        format: (val) => (val != null ? moment(val).format("DD/MMM/YYYY") : ""),

        sortable: true,
      },
      {
        name: "Starting Location",
        align: "right",
        label: "Location",
        field: "location",
        format: (val) => (val != null ? `${val.split(",")[0]}` : ""),
        sortable: true,
      },
    ],
    pagination: {
      rowsPerPage: 0,
    },
    selected: [],

    separator: "vertical",
  }),
  beforeCreate() {
    this.$store.dispatch("loadScheduledSurveys");
    console.log(1);
    console.log(
      this.currentUserData,
      this.currentUserData.id,
      this.currentUser
    );
    if (!this.currentUserData && !this.currentUserData.id) {
      // this.$swal({
      //   title: "Warning",
      //   text: "You are not currently logged in which will cause for some features to be unavailable, Do you want to login?",
      //   type: "warning",
      //   confirmButtonText: "Login",
      //   cancelButtonText: "Continue",
      //   showCancelButton: true,
      //   confirmButtonColor: "#3284E3",
      // }).then((res) => {
      //   if (res.value) {
      //     this.$auth.loginWithPopup();
      //   }
      // });
    }
  },
  mounted() {
    setTimeout(() => {
      this.maxHeight = this.$refs.titleOfPage.clientHeight + 60;
    }, 100);
  },
  methods: {
    handleClick(evt, row, index) {
      this.selected = [row];
    },
    handleDoubleClick(row) {
      this.$router.push(`/mobile-view/mp-survey/${row.id}`);
    },
  },
};
</script>
